/**
 * Kundenlink je Immobilie: Die Merkmale des Risikos kommen über
 * `GET public-form/:token` als flache Liste (`immobilie.answers`, Werte als
 * Text). Gespeichert wurden sie aus `{...global, ...gebaeude[0].answers,
 * gebaeudeLabel}` — hier wird das wieder auseinandergenommen.
 *
 * Wichtig: ALLE Merkmale müssen ins Formular. Der Server ersetzt beim
 * Speichern den kompletten Merkmalsbestand (Semantik `PUT risk-objects/:id`);
 * was das Formular nicht kennt, aber nicht zurückschickt, wäre danach weg.
 */

/** Diese Schlüssel gehören zur Anschrift, nicht zum Gebäude. */
export const GLOBALE_SCHLUESSEL = ["street", "postalCode", "city", "country", "hasMultiple"] as const;

export type KundenlinkImmobilie = {
  riskObjectId: number;
  name: string;
  answers: Record<string, string>;
};

export const teileImmobilienMerkmale = (
  answers: Record<string, unknown>,
): { global: Record<string, unknown>; gebaeude: Record<string, unknown>; label: string } => {
  const global: Record<string, unknown> = {};
  const gebaeude: Record<string, unknown> = {};
  let label = "";
  for (const [k, v] of Object.entries(answers ?? {})) {
    if ((GLOBALE_SCHLUESSEL as readonly string[]).includes(k)) global[k] = v;
    else if (k === "gebaeudeLabel") label = typeof v === "string" ? v : "";
    else gebaeude[k] = v;
  }
  return { global, gebaeude, label };
};

export const alsKundenlinkImmobilie = (v: unknown): KundenlinkImmobilie | null => {
  const o = v as Partial<KundenlinkImmobilie> | null | undefined;
  if (!o || typeof o.riskObjectId !== "number" || !o.answers || typeof o.answers !== "object") {
    return null;
  }
  return { riskObjectId: o.riskObjectId, name: String(o.name ?? ""), answers: o.answers };
};
